import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { ChangePasswordComponent } from './modules/change-password/change-password.component';
// import { RegisterComponent } from './modules/register/register.component';

const routes: Routes = [
  { path: "login", component: LoginComponent, data: { title: "Iniciar sesión" } },
  { path: "change-password", component: ChangePasswordComponent, data: { title: "Cambiar contraseña" } },
  // { path: "register", component: RegisterComponent },
  { path: "", redirectTo: "login", pathMatch: "prefix" }, { path: "**", redirectTo: "login", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
